<template>
  <VModal :type="ModalType.custom" :color="ColorType.gray" :isScroll="false">
    <VBlock class="coupon-wrapper" :sort="Sort.left_top" :direction="Direction.column">
      <VBlock class="coupon-header" :sort="Sort.space_between">
        <VBlock class="stock-wrapper">
          <VStockButton
            :type="StockButtonType.exit"
            :clickEvent="onExit"
            :width="16"
            :height="16"
          />
        </VBlock>
        <VSpan class="text" text="할인쿠폰" :size="16" :weight="TextWeight.bold" />
        <div class="blank"></div>
      </VBlock>
      <VBlock
        class="coupon-contents"
        ref="scrollLayer"
        :sort="Sort.left_top"
        :direction="Direction.column"
      >
        <VList>
          <VListItem
            v-if="params.coupon.options.filter(coupon => coupon.firstPurchaseCoupon).length > 0"
          >
            <VBlock :direction="Direction.column" :sort="Sort.left_top">
              <VP
                text="첫 주문 전용 쿠폰"
                class="first-purchase-coupon-title"
                :color="TextColor.black"
                :size="16"
                :weight="TextWeight.bold"
              />
              <VP
                text="B마트 첫 주문 시, 1장을 선택해 사용 가능합니다."
                class="first-purchase-description"
                :color="TextColor.brand"
                :size="14"
              />

              <PreOrderCouponList
                :params="params"
                :onOK="onOK"
                :onCancel="onCancel"
                :selectedCoupon="selectedCoupon"
                :setCoupon="setCoupon"
                :isAvailable="isAvailable"
                :coupons="params.coupon.options.filter(coupon => coupon.firstPurchaseCoupon)"
              />
            </VBlock>
          </VListItem>
          <VListItem>
            <VP
              text="이런 쿠폰도 있어요!"
              class="coupon-title"
              :color="TextColor.black"
              :size="16"
              :weight="TextWeight.bold"
              v-if="
                params.coupon.options.filter(coupon => coupon.firstPurchaseCoupon).length > 0 &&
                  params.coupon.options.filter(coupon => !coupon.firstPurchaseCoupon).length > 0
              "
            />

            <PreOrderCouponList
              :params="params"
              :onOK="onOK"
              :onCancel="onCancel"
              :selectedCoupon="selectedCoupon"
              :setCoupon="setCoupon"
              :isAvailable="isAvailable"
              :coupons="params.coupon.options.filter(coupon => !coupon.firstPurchaseCoupon)"
            />
            <VListItem class="footer-item-wrapper">
              <VBlock
                class="footer-wrapper"
                :direction="Direction.column"
                v-if="params.coupon.options.length > 0"
              >
                <VHR class="hr-line" :color="LineColor.gray3" />
                <VBlock class="footer-description-wrapper">
                  <VP
                    class="footer-description"
                    text="B마트에서 사용 가능한 할인쿠폰 목록입니다"
                    :color="TextColor.gray2"
                    :size="12"
                  />
                </VBlock>
              </VBlock>
            </VListItem>
          </VListItem>
        </VList>
      </VBlock>

      <VBlock class="coupon-footer" :direction="Direction.column">
        <VButton
          class="coupon-apply-button"
          :radius="4"
          :style="{ opacity: !selectedCoupon ? '0.3' : '1' }"
          :color="!selectedCoupon ? ButtonColor.inactive : ButtonColor.brand"
          :onClick="doSelect"
        >
          <VSpan text="적용하기" :color="TextColor.white" :size="18" :weight="TextWeight.bold" />
        </VButton>
      </VBlock>
    </VBlock>
  </VModal>
</template>

<script>
import VHR, { LineColor } from '@/presentationals/v2/components/layouts/atoms/VHR'
import VP from '../../atoms/VP'
import VA from '@/presentationals/v2/components/layouts/molecules/VA'

import VButton, { ButtonColor } from '@/presentationals/v2/components/layouts/atoms/VButton'
import VSpan, {
  TextColor,
  TextWeight,
  TextType
} from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VStockButton, {
  StockButtonType
} from '@/presentationals/v2/components/layouts/atoms/VStockButton'
import VImage from '@/presentationals/v2/components/layouts/atoms/VImage'

import VBlock, { Sort, Direction } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VCard from '@/presentationals/v2/components/layouts/molecules/VCard'
import VList from '@/presentationals/v2/components/layouts/molecules/VList'
import VListItem from '@/presentationals/v2/components/layouts/molecules/VListItem'
import VModal, {
  ModalType,
  ColorType
} from '@/presentationals/v2/components/layouts/molecules/VModal'
import PreOrderCouponList from '@/presentationals/v2/components/layouts/organisms/PreOrderCouponList'

import selectedIcon from '@/assets/images/confirm-input-24.svg'

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default {
  name: 'ModalCoupon',
  props: {
    title: {
      type: String,
      required: true
    },
    onOK: {
      type: Function,
      required: true
    },
    onCancel: {
      type: Function
    },
    params: {
      type: Object,
      required: true
    }
  },
  components: {
    VP,
    VButton,
    VHR,
    VA,
    VImage,

    VSpan,
    VStockButton,

    VBlock,
    VCard,
    VList,
    VListItem,
    VModal,

    PreOrderCouponList
  },
  computed: {
    appVersion() {
      return this.$store.getters.appVersion
    }
  },
  methods: {
    setCoupon(coupon) {
      if (!this.selectedCoupon) this.selectedCoupon = coupon
      else if (this.selectedCoupon.id !== coupon.id) this.selectedCoupon = coupon
      else this.selectedCoupon = null
    },

    onExit() {
      if (!this.selectedCoupon) {
        this.params.onCoupon(null)
      }
      this.onCancel()
    },

    doSelect() {
      if (!this.selectedCoupon) return
      this.onOK()
      this.params.onCoupon(this.selectedCoupon)
    },

    isAvailable(coupon) {
      const { available, displayProductIds, displayCatalogIds } = coupon

      const checkHasCatalogIds = target => {
        return displayCatalogIds.includes(target)
      }

      const checkHasProductIds = target => {
        return displayProductIds.includes(target)
      }

      if (displayCatalogIds.length === 0 && displayProductIds.length === 0) {
        return available
      } else if (displayCatalogIds.length === 0) {
        return (
          available &&
          this.normalizeDatas.productIds.some(productId => checkHasProductIds(productId))
        )
      } else if (displayProductIds.length === 0) {
        return (
          available &&
          this.normalizeDatas.catalogIds.some(catalogId => checkHasCatalogIds(catalogId))
        )
      }

      // 둘 다 배열이 차 있는 경우

      return (
        // available 이면서
        available &&
        (this.normalizeDatas.productIds.some(productId => checkHasProductIds(productId)) ||
          this.normalizeDatas.catalogIds.some(catalogId => checkHasCatalogIds(catalogId)))
      )
    }
  },
  created() {
    const { appVersion } = this.$store.getters
    this.$store.commit('hideNavigationBar', { appVersion })

    const CATALOGIDS = 'catalogIds'
    const PRODUCTIDS = 'productIds'

    this.normalizeDatas = this.params.products.reduce((acc, curr) => {
      acc[CATALOGIDS] = [...(acc[CATALOGIDS] || []), ...curr.catalogIds.sort()]
      acc[PRODUCTIDS] = [...(acc[PRODUCTIDS] || []), curr.productId]

      return acc
    }, [])
  },
  mounted() {
    if (!!this.$refs.scrollLayer) disableBodyScroll(this.$refs.scrollLayer.$el)
  },
  beforeDestroy() {
    const { appVersion } = this.$store.getters
    this.$store.commit('showNavigationBar', { appVersion })
    if (!!this.$refs.scrollLayer) enableBodyScroll(this.$refs.scrollLayer.$el)
  },
  data() {
    return {
      ButtonColor,
      TextColor,
      TextWeight,
      TextType,
      Direction,
      Sort,
      ModalType,
      StockButtonType,
      ColorType,
      LineColor,

      selectedCoupon: !this.params.coupon.selected ? null : this.params.coupon.selected[0],

      resources: {
        selectedIcon
      },

      normalizeDatas: []
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.coupon-wrapper {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  background-color: $background-gray;

  .coupon-header {
    padding: 10px 15px 10px 15px;
    align-items: center;
    box-sizing: border-box;
    background-color: $background-white;
    border-bottom: 1px solid $light-gray-4;

    .text {
      height: 19px;
      vertical-align: middle;
    }

    .stock-wrapper {
      width: 24px;
      height: 24px;
    }

    .blank {
      width: 30px;
    }
  }

  .coupon-contents {
    width: 100%;
    height: calc(100vh - 95px);
    height: calc(100vh - (constant(safe-area-inset-bottom) - 95px));
    height: calc(100vh - (env(safe-area-inset-bottom) - 95px));
    padding: 15px;
    box-sizing: border-box;
    overflow-y: auto;
    position: relative;

    .coupon-title {
      text-align: left;
      margin-top: 20px;
      margin-bottom: 10px;
      margin-left: 5px;
    }

    .first-purchase-coupon-title {
      text-align: left;
      margin-bottom: 6px;
      margin-left: 5px;
      margin-top: 5px;
    }

    .first-purchase-description {
      text-align: left;
      margin-bottom: 10px;
      margin-left: 5px;
    }

    .footer-item-wrapper {
      width: 100%;
    }

    .footer-wrapper {
      position: relative;
      width: 100%;
      height: 50px !important;

      .hr-line {
        width: 100%;
        margin-bottom: 12px;
      }

      .footer-description-wrapper {
        width: 100%;
        height: auto;
        padding: 0 12px 0 12px;

        // .footer-description {
        // margin-bottom: 16px;
        // }
      }
    }

    .coupon-list {
      height: auto;
      box-sizing: border-box;
    }
  }

  .coupon-footer {
    width: 100%;
    height: 50px !important;
    // height: 126px !important;
    // height: 70px !important;
    box-sizing: border-box;
    padding: 0 10px;
    margin-bottom: 10px;
    margin-bottom: calc(constant(safe-area-inset-bottom) + 10px);
    margin-bottom: calc(env(safe-area-inset-bottom) + 10px);

    .coupon-apply-button {
      width: 100%;
      height: 50px !important;
      // box-sizing: border-box;
      // padding: 15px 0 15px 0;
    }
  }
}
</style>
